import ENV from 'env';

export default class Base {
  constructor ($http) {
    'ngInject';

    this.apiUrl = ENV.apiUrl;
    this.$http = $http;
    this.pingstaApiUrl = ENV.apiUrl + '/pingsta';
  }

  getList(resourcePath) {
    return this.$http.get(this.pingstaApiUrl + resourcePath).then(response => response.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/util/base.service.js